export default __webpack_public_path__ + "68ead4c1f8183082dea8cf2e166094c2.jpg";